import { useQuery } from "@tanstack/react-query";
import { CustomerAddressModel } from "../models";
import { GetSavedAddresses } from "../services";

export const useSavedAddresses = (
  customerId: string | number | null | undefined,
  enabled: boolean,
) => {
  return useQuery<CustomerAddressModel[]>({
    queryKey: ["saved-addresses", customerId, "901"],

    queryFn: async () => {
      const { status, data } = await GetSavedAddresses({
        customer_id: customerId,
        address_type: "901",
      });

      if (!status) {
        throw new Error("Failed to fetch saved addresses");
      }

      return data ?? [];
    },

    enabled: enabled && Boolean(customerId),

    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: false,
  });
};
